import React, { useState, createContext } from "react";

export const UserContext = createContext();

export const UserProvider = (props) => {
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const [user, setUser] = useState(currentUser);

  return (
    <UserContext.Provider value={{user, setUser}}>
      {props.children}
    </UserContext.Provider>
  );
};
